const MinimizeIcon = ({ fillColor = "#8800FF", width = "18", height = "18" }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.34033 8.03906H12.6737"
				stroke={fillColor}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default MinimizeIcon;
